import { render, staticRenderFns } from "./blog-category-list.vue?vue&type=template&id=2c97d835&scoped=true&"
import script from "./blog-category-list.vue?vue&type=script&lang=js&"
export * from "./blog-category-list.vue?vue&type=script&lang=js&"
import style0 from "./blog-category-list.vue?vue&type=style&index=0&id=2c97d835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97d835",
  null
  
)

export default component.exports